import { render, staticRenderFns } from "./MultipleImageWrapper.vue?vue&type=template&id=cb5e9538&scoped=true"
import script from "./MultipleImageWrapper.vue?vue&type=script&lang=ts"
export * from "./MultipleImageWrapper.vue?vue&type=script&lang=ts"
import style0 from "./MultipleImageWrapper.vue?vue&type=style&index=0&id=cb5e9538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5e9538",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowGalleryTheSwiper: require('/usr/src/nuxt-app/components/show/gallery/TheSwiper.vue').default})
